/**
 * Kontrakt „przenieś dane do kartoteki" — wspólny dla kolejki próśb o konto,
 * formularza podwykonawcy i sekcji kont na karcie firmy.
 *
 * Dane lecą przez `state` nawigacji Reacta, a nie przez adres URL: to dane
 * kontaktowe firmy, które nie mają czego szukać w historii przeglądarki ani w
 * logach serwera.
 */

export interface ContractorPrefill {
  name: string;
  nip: string;
  contact_person: string;
  contact_email: string;
  contact_phone: string;
}

export interface ContractorUserPrefill {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  can_access_rfq: boolean;
}

export interface ContractorFlowState {
  /** Czym wypełnić pusty formularz nowego podwykonawcy. */
  contractorPrefill?: ContractorPrefill;
  /** Otwórz od razu formularz nowego konta i wypełnij go tymi danymi. */
  openUserForm?: ContractorUserPrefill;
  /** Zgłoszenie z kolejki „Prośby o konto", które ta ścieżka domyka. */
  accountRequestId?: string;
}

/**
 * Rozbij „Jan Kowalski" na imię i nazwisko.
 *
 * Zgłoszenie ma jedno pole na osobę kontaktową, a konto wymaga dwóch. Podział jest
 * zgadywaniem, więc trafia do formularza do poprawienia, a nie prosto do zapisu.
 */
export function splitPersonName(full: string): {
  first_name: string;
  last_name: string;
} {
  const parts = (full || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first_name: "", last_name: "" };
  return { first_name: parts[0], last_name: parts.slice(1).join(" ") };
}
